import { useEffect, useState } from 'react';
import Card from './components/Card/Card';
import styles from './NewsPage.module.scss';
import { useGetAllNews } from '../../../queries/news/useGetAllNews';
import { IGetAllNewsResponse } from '../../../types/news';
import { Container } from '../../Container/Container';

const NewsPage = () => {
  const { allNewsData, setPage, page, isGetAllNewsSuccess } = useGetAllNews({
    sort: '-publicationDatetime',
  });

  const [items, setItems] = useState<IGetAllNewsResponse['docs']>([]);

  useEffect(() => {
    if (allNewsData?.docs && isGetAllNewsSuccess) {
      if (page === 1) return setItems(allNewsData.docs);

      setItems((prev) => [...prev, ...allNewsData.docs]);
    }
  }, [allNewsData?.docs, isGetAllNewsSuccess, page]);

  return (
    <div className={styles.NewsPage}>
      <Container>
        <h1>Обновления Groupe SEB</h1>
        {allNewsData ? (
          <>
            {allNewsData.docs.length > 0 ? (
              items.map((item, index) => (
                <Card
                  annotation={item.text}
                  date={item.publicationDatetime}
                  image={item.image}
                  title={item.title}
                  key={index}
                />
              ))
            ) : (
              <p>Новостей нет</p>
            )}
          </>
        ) : (
          <p>Загрузка...</p>
        )}

        {allNewsData?.hasNextPage && (
          <div className={styles.button_wrapper}>
            <button onClick={() => setPage((prev) => ++prev)}>
              Посмотреть еще
            </button>
          </div>
        )}
      </Container>
    </div>
  );
};

export default NewsPage;
